import React from 'react'

import rental11 from './assets/rental-1_1.svg'
import rental12 from './assets/rental-1_2.png'
import rental21 from './assets/rental-2_1.svg'
import rental22 from './assets/rental-2_2.png'
import './style.scss'

const RentalIssue = () => {
  return (
    <div className='rental-issue'>
      <h1 className='auth-heading-1'>
        Mietprobleme waren gestern –<span>jetzt sorgenfrei wohnen!</span>
      </h1>
      <p>Kostenlos anmelden und Mietprobleme lösen.</p>
      <div className='rental-content'>
        <img
          src={rental11}
          alt='Rental img'
          width='205px'
          height='210px'
          style={{ top: 0, left: 0, zIndex: 1 }}
        />
        <img
          src={rental12}
          alt='Rental img'
          width='251'
          height='252'
          style={{ top: 154, left: 111, zIndex: 0 }}
        />
        <img
          src={rental21}
          alt='Rental img'
          width='165'
          height='168'
          style={{ top: 0, right: 0, zIndex: 1 }}
        />
        <img
          src={rental22}
          alt='Rental img'
          width='210'
          height='226'
          style={{ top: 115, right: 95, zIndex: 0 }}
        />
      </div>
    </div>
  )
}

export default RentalIssue
